"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var style_exports = {};
__export(style_exports, {
  convertFontWeightToStringFontWeight: () => convertFontWeightToStringFontWeight,
  flattenStyle: () => flattenStyle
});
module.exports = __toCommonJS(style_exports);
function flattenStyle(style) {
  if (!style) {
    return void 0;
  }
  if (!Array.isArray(style)) {
    return style;
  }
  var result;
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = style[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;
      var flat = flattenStyle(item);
      if (flat) {
        result = {
          ...result,
          ...flat
        };
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return result;
}
function convertFontWeightToStringFontWeight(fontWeight) {
  if (fontWeight === void 0) {
    return void 0;
  }
  if (typeof fontWeight === "number") {
    return String(fontWeight);
  }
  return fontWeight;
}
//# sourceMappingURL=style.js.map
